import React from 'react'

import { RingProgress } from '@tidbcloud/uikit'

interface RefreshProgressProps {
  value: number
}

const RefreshProgress: React.FC<
  React.PropsWithChildren<RefreshProgressProps>
> = ({ value }) => {
  return (
    <RingProgress
      mx={-4}
      size={22}
      thickness={4}
      rootColor='carbon.5'
      sections={[{ value, color: 'carbon.8' }]}
    />
  )
}

export default RefreshProgress
